import React from 'react'
import Seo from '../../Components/SEO/Seo';


export default function FourZeroOnePage() {
  return (
  <div className='split-pane pane-right'>
      <div className='container no-gutter'>
        <Seo title="401: Not Authorized"/>
        <h1>UNAUTHORIZED</h1>
        <h3>Access is denied</h3>
      </div>
  </div>
  );
}